import React from "react";
import { useTranslation } from "react-i18next";
import useDelete from "src/hooks/rest/useDelete";
import { ApiProfileMinimal } from "src/api/types";
import Avatar from "src/components/Avatar";
import Button from "src/components/Button";
import Card from "src/components/Card";
import ProfileBadge from "src/components/ProfileBadge/ProfileBadge";
import Stars from "src/components/Stars";

interface NetworkStudentCardProps {
	profile: ApiProfileMinimal;
	onSubmit: (profile: ApiProfileMinimal) => void;
}

const NetworkStudentCard = ({ profile, onSubmit }: NetworkStudentCardProps) => {
	const { t } = useTranslation("network", {
		keyPrefix: "network-student-card",
	});

	const [removeConnection, loading] = useDelete(
		`/connections/${profile.hid}`
	);
	const handleRemove = () => {
		removeConnection().then(() => {
			onSubmit(profile);
		});
	};
	const renderTelephone = (hid: string, telephone?: any) => {
		if (!telephone) return <></>;
		return (
			<div className="flex relative items-center">
				<span className="mb-0">Tel: {telephone}</span>
			</div>
		);
	};
	return (
		<Card className="" contentClassName="p-8 flex flex-col gap-4">
			<div className="flex gap-2 flex-wrap md:flex-row items-center flex-col justify-between">
				<div className="flex items-center gap-2">
					<Avatar
						src={profile.avatar}
						size="regular"
						alt={profile.full_name}
					/>
					<div className="">
						<h3>{profile.full_name}</h3>
						<Stars rating={profile?.reviews?.rating} />
						{renderTelephone(
							profile?.hid || "",
							profile?.telephone
						)}
					</div>
				</div>

				{profile.badges?.length > 0 && (
					<div className="flex flex-row">
						{profile.badges.map((badge, index) => (
							<div
								key={`header-${badge.type}`}
								className={index !== 0 ? `-ml-2` : undefined}
							>
								<ProfileBadge
									variant="logo-only"
									className="w-[32px]"
									{...{ badge }}
								/>
							</div>
						))}
					</div>
				)}
			</div>
			<div className="flex-1"></div>
			<div className="flex flex-col gap-4">
				<Button
					disabled={loading}
					small
					to={`/tasks/create?profile=${profile.hid}`}
				>
					<i className="fas fa-plus mr-2"></i> {t("create-task")}
				</Button>
				<Button
					disabled={loading}
					small
					type="gray"
					to={`/view-profile/${profile.hid}`}
				>
					<i className="fas fa-user mr-2"></i>
					{t("view-profile")}
				</Button>
				<Button
					className="col-span-2"
					small
					onClick={handleRemove}
					type="outline"
					{...{ loading }}
				>
					<i className="fas fa-trash mr-2"></i>
					{t("delete-connection")}
				</Button>
			</div>
		</Card>
	);
};

export default NetworkStudentCard;
